import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import editClaimSecondaryQualifierAPI from '../../../api/services/MergeClaims/editClaimSecondaryQualifier.service';
import getAllClaimByIdTypeAPI from '../../../api/services/MergeClaims/getAllClaimByIdType.service';
import getAllClaimErrorCountAPI from '../../../api/services/MergeClaims/getAllClaimErrorCount';
import getClaimByIdAPI from '../../../api/services/MergeClaims/getClaimById.service';
import getDropdownDataInsuranceAPI from '../../../api/services/MergeClaims/getDropdownDataInsurance.service';
import getSelectedBillingDataAPI from '../../../api/services/MergeClaims/getSelectedBillingData.service';
import BillingGrids from '../../../api/services/Billing/BillingGrid.service';
const initialState = {
    gridData: [],
    selectedBilling: [],
    organizationEmployee: [],
    ClaimByIdType: [],
    claimById: [],
    allSecondaryQualifierDataCategoryByType: [],
    secondaryQualifierByClaimIdBilling: [],
    secondaryQualifierByClaimIdSupplier: [],
    secondaryQualifierByClaimIdFacility: [],
    secondaryQualifierByClaimIdSupervising: [],
    allPayorResponsibility: [],
    allFillingType: [],
    allInsuranceIdType: [],
    allInsuranceType: [],
    clientPayor: [],
    clientPayorInsurance: [],
    pointersCount: 0,
    childPayerId: '',
    errorCounts: [
        {
            claimId: 670,
            errorCount: 4,
            type: 'PROVIDER',
            subType: 'PROVIDER_SUPPLIER',
            typeId: 670,
        },
        {
            claimId: 670,
            errorCount: 9,
            type: 'PROVIDER',
            subType: 'BILLING',
            typeId: 533,
        },
        {
            claimId: 670,
            errorCount: 7,
            type: 'PROVIDER',
            subType: 'FACILITY',
            typeId: 303,
        },
        {
            claimId: 670,
            errorCount: 7,
            type: 'CLAIM',
            subType: 'DETAIL',
            typeId: 234,
        },
        {
            claimId: 670,
            errorCount: 9,
            type: 'PATIENT',
            subType: 'INSURANCE',
            typeId: 0,
        },
        {
            claimId: 670,
            errorCount: 9,
            type: 'PATIENT',
            subType: 'SUBSCRIBER',
            typeId: 0,
        },
        {
            claimId: 670,
            errorCount: 11,
            type: 'PATIENT',
            subType: 'PATIENT',
            typeId: 0,
        },
    ],
    errorCountBackend: [],
    isPrimaryCode: false,
    billingCode: [],
};
interface MyData1 {
    billingIds: any;
}
interface MyData2 {
    id: any;
}
interface MyData3 {
    type: any;
}
interface MyData4 {
    id: any;
    type: any;
}
interface MyData5 {
    payorId: any;
    clientId: any;
    authorizationCodeId: any;
}
interface MyData7 {
    payorId: any;
    clientId: any;
    insuranceId: any;
}
interface MyData8 {
    claimId: any;
}
export const getAllClaimErrorCount = createAsyncThunk(
    'getAllClaimErrorCount',
    async (payload: MyData8, { rejectWithValue }) => {
        try {
            const res =
                await getAllClaimErrorCountAPI.getAllClaimErrorCount(payload);
            return res.data.data;
        } catch (err) {
            rejectWithValue('Error in Response');
        }
    }
);
export const getSelectedBillingDataCall = createAsyncThunk(
    'getSelectedBillingDataCall',
    async (payload: MyData1, { rejectWithValue }) => {
        try {
            const res =
                await getSelectedBillingDataAPI.getSelectedBillingData(payload);
            return res.data.data;
        } catch (err) {
            rejectWithValue('Error in Response');
        }
    }
);
export const getClaimByIdCall = createAsyncThunk(
    'getClaimByIdCall',
    async (payload: MyData2, { rejectWithValue }) => {
        try {
            const res = await getClaimByIdAPI.getClaimById(payload);
            return res.data.data;
        } catch (err) {
            rejectWithValue('Error in Response');
        }
    }
);
export const getAllSecondaryQualifierDataCategoryByType = createAsyncThunk(
    'getAllSecondaryQualifierDataCategoryByType',
    async (payload: MyData3, { rejectWithValue }) => {
        try {
            const res =
                await editClaimSecondaryQualifierAPI.getAllSecondaryQualifierDataCategoryByType(
                    payload
                );
            return res.data.data;
        } catch (err) {
            rejectWithValue('Error in Response');
        }
    }
);
export const getSecondaryQualifierByClaimIdBilling = createAsyncThunk(
    'getSecondaryQualifierByClaimIdBilling',
    async (payload: MyData4, { rejectWithValue }) => {
        try {
            const res =
                await editClaimSecondaryQualifierAPI.getSecondaryQualifierByClaimId(
                    payload
                );
            return res.data.data;
        } catch (err) {
            rejectWithValue('Error in Response');
        }
    }
);
export const getSecondaryQualifierByClaimIdSupplier = createAsyncThunk(
    'getSecondaryQualifierByClaimIdSupplier',
    async (payload: MyData4, { rejectWithValue }) => {
        try {
            const res =
                await editClaimSecondaryQualifierAPI.getSecondaryQualifierByClaimId(
                    payload
                );
            return res.data.data;
        } catch (err) {
            rejectWithValue('Error in Response');
        }
    }
);
export const getSecondaryQualifierByClaimIdFacility = createAsyncThunk(
    'getSecondaryQualifierByClaimIdFacility',
    async (payload: MyData4, { rejectWithValue }) => {
        try {
            const res =
                await editClaimSecondaryQualifierAPI.getSecondaryQualifierByClaimId(
                    payload
                );
            return res.data.data;
        } catch (err) {
            rejectWithValue('Error in Response');
        }
    }
);
export const getSecondaryQualifierByClaimIdSupervising = createAsyncThunk(
    'getSecondaryQualifierByClaimIdSupervising',
    async (payload: MyData4, { rejectWithValue }) => {
        try {
            const res =
                await editClaimSecondaryQualifierAPI.getSecondaryQualifierByClaimId(
                    payload
                );
            return res.data.data;
        } catch (err) {
            rejectWithValue('Error in Response');
        }
    }
);
export const getClientPayorCall = createAsyncThunk(
    'getClientPayorCall',
    async (payload: MyData5, { rejectWithValue }) => {
        try {
            const res =
                await getDropdownDataInsuranceAPI.getClientPayor(payload);
            return res.data.data;
        } catch (err) {
            rejectWithValue('Error in Response');
        }
    }
);
export const getClientPayorInsuranceCall = createAsyncThunk(
    'getClientPayorInsuranceCall',
    async (payload: MyData7, { rejectWithValue }) => {
        try {
            const res =
                await getDropdownDataInsuranceAPI.getClientPayorInsurance(
                    payload
                );
            return res.data.data;
        } catch (err) {
            rejectWithValue('Error in Response');
        }
    }
);
export const getOrganizationEmployeeCall = createAsyncThunk(
    'getOrganizationEmployeeCall',
    async (_, thunkAPI) => {
        try {
            const res =
                await getSelectedBillingDataAPI.getOrganizationEmployee();
            return res.data.data;
        } catch (err) {
            // Return the error to be handled by the rejection action
            return thunkAPI.rejectWithValue(err);
        }
    }
);
export const getAllClaimByIdTypeCall = createAsyncThunk(
    'getAllClaimByIdTypeCall',
    async (_, thunkAPI) => {
        try {
            const res = await getAllClaimByIdTypeAPI.getAllClaimByIdType();
            return res.data.data;
        } catch (err) {
            // Return the error to be handled by the rejection action
            return thunkAPI.rejectWithValue(err);
        }
    }
);
export const getAllPayorResponsibilityCall = createAsyncThunk(
    'getAllPayorResponsibilityCall',
    async (_, thunkAPI) => {
        try {
            const res =
                await getDropdownDataInsuranceAPI.getAllPayorResponsibility();
            return res.data.data;
        } catch (err) {
            // Return the error to be handled by the rejection action
            return thunkAPI.rejectWithValue(err);
        }
    }
);
export const getAllInsuranceIdTypeCall = createAsyncThunk(
    'getAllInsuranceIdTypeCall',
    async (_, thunkAPI) => {
        try {
            const res =
                await getDropdownDataInsuranceAPI.getAllInsuranceIdType();
            return res.data.data;
        } catch (err) {
            // Return the error to be handled by the rejection action
            return thunkAPI.rejectWithValue(err);
        }
    }
);
export const getAllFillingTypeCall = createAsyncThunk(
    'getAllFillingTypeCall',
    async (_, thunkAPI) => {
        try {
            const res = await getDropdownDataInsuranceAPI.getAllFillingType();
            return res.data.data;
        } catch (err) {
            // Return the error to be handled by the rejection action
            return thunkAPI.rejectWithValue(err);
        }
    }
);
export const getAllInsuranceTypeCall = createAsyncThunk(
    'getAllInsuranceTypeCall',
    async (_, thunkAPI) => {
        try {
            const res = await getDropdownDataInsuranceAPI.getAllInsuranceType();
            return res.data.data;
        } catch (err) {
            // Return the error to be handled by the rejection action
            return thunkAPI.rejectWithValue(err);
        }
    }
);
export const getBillingCodeFromBilling = createAsyncThunk(
    'getBillingCodeFromBilling',
    async (_, thunkAPI) => {
        try {
            const res = await BillingGrids.getBillingCodeFromBilling();
            return res.data.data;
        } catch (err) {
            // Return the error to be handled by the rejection action
            return thunkAPI.rejectWithValue(err);
        }
    }
);
const mergeClaims = createSlice({
    name: 'mergeClaims',
    initialState,
    reducers: {
        setMultipleGridData: (state, action) => {
            state.gridData = action.payload;
        },
        setPointersCount: (state, action) => {
            state.pointersCount = action.payload;
        },
        setChildPayerId: (state, action) => {
            state.childPayerId = action.payload;
        },
        setIsPrimaryCode: (state, action) => {
            state.isPrimaryCode = action.payload;
        },
        clearDataClaims: (state) => {
            state.ClaimByIdType = [];
            state.claimById = [];
            state.selectedBilling = [];
            state.secondaryQualifierByClaimIdBilling = [];
            state.secondaryQualifierByClaimIdSupplier = [];
            state.secondaryQualifierByClaimIdFacility = [];
            state.secondaryQualifierByClaimIdSupervising = [];
        },
        updateErrorCount: (state: any, action: any) => {
            const { type, subType, newErrorCount } = action.payload;
            state.errorCounts = state.errorCounts.map((error: any) => {
                if (error.type === type && error.subType === subType) {
                    return {
                        ...error,
                        errorCount: newErrorCount,
                    };
                }
                return error;
            });
        },
    },
    extraReducers: (builder) => {
        builder
            .addCase(getSelectedBillingDataCall.pending, () => {})
            .addCase(
                getSelectedBillingDataCall.fulfilled,
                (state: any, action) => {
                    state.selectedBilling = action.payload;
                }
            )
            .addCase(getAllClaimErrorCount.fulfilled, (state: any, action) => {
                state.errorCountBackend = action.payload;
            })
            .addCase(
                getAllClaimByIdTypeCall.fulfilled,
                (state: any, action) => {
                    state.ClaimByIdType = action.payload;
                }
            )
            .addCase(
                getOrganizationEmployeeCall.fulfilled,
                (state: any, action) => {
                    state.organizationEmployee = action.payload;
                }
            )
            .addCase(
                getAllSecondaryQualifierDataCategoryByType.fulfilled,
                (state: any, action) => {
                    state.allSecondaryQualifierDataCategoryByType =
                        action.payload;
                }
            )
            .addCase(
                getSecondaryQualifierByClaimIdBilling.fulfilled,
                (state: any, action) => {
                    state.secondaryQualifierByClaimIdBilling = action.payload;
                }
            )
            .addCase(
                getSecondaryQualifierByClaimIdSupplier.fulfilled,
                (state: any, action) => {
                    state.secondaryQualifierByClaimIdSupplier = action.payload;
                }
            )
            .addCase(
                getSecondaryQualifierByClaimIdFacility.fulfilled,
                (state: any, action) => {
                    state.secondaryQualifierByClaimIdFacility = action.payload;
                }
            )
            .addCase(
                getSecondaryQualifierByClaimIdSupervising.fulfilled,
                (state: any, action) => {
                    state.secondaryQualifierByClaimIdSupervising =
                        action.payload;
                }
            )
            .addCase(getClaimByIdCall.fulfilled, (state: any, action) => {
                state.claimById = action.payload;
            })
            .addCase(
                getAllPayorResponsibilityCall.fulfilled,
                (state: any, action) => {
                    state.allPayorResponsibility = action.payload;
                }
            )
            .addCase(getAllFillingTypeCall.fulfilled, (state: any, action) => {
                state.allFillingType = action.payload;
            })
            .addCase(
                getAllInsuranceIdTypeCall.fulfilled,
                (state: any, action) => {
                    state.allInsuranceIdType = action.payload;
                }
            )
            .addCase(
                getAllInsuranceTypeCall.fulfilled,
                (state: any, action) => {
                    state.allInsuranceType = action.payload;
                }
            )
            .addCase(
                getBillingCodeFromBilling.fulfilled,
                (state: any, action) => {
                    state.billingCode = action.payload;
                }
            )

            .addCase(getClientPayorCall.fulfilled, (state: any, action) => {
                state.clientPayor = action.payload;
            })
            .addCase(
                getClientPayorInsuranceCall.fulfilled,
                (state: any, action) => {
                    state.clientPayorInsurance = action.payload;
                }
            )
            .addCase(getSelectedBillingDataCall.rejected, () => {});
    },
});
export const {
    setMultipleGridData,
    clearDataClaims,
    setPointersCount,
    setChildPayerId,
    setIsPrimaryCode,
    updateErrorCount,
} = mergeClaims.actions;
export default mergeClaims.reducer;
